import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoDeleteVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoDeleteVO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly value: RoomBrandLogoDelete) {
    JsonSchemaValidator.assert(RoomBrandLogoDeleteVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoDelete {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
